import { googleMaps as LocaleLookupTable } from '../config';

export function mapsLocaleLookup(locale) {
  return LocaleLookupTable[locale] || locale;
}

export default mapsLocaleLookup;
